<div class="row justify-content-center" [ngClass]="routeAnimationsElements">

    <div class="col-md-8">
        <mat-card>
            <rpe-integrante-form [formInput]="formInput" (formValueChanges)="formValueChanges($event)"
                (formStatusChanges)="formStatusChanges($event)"></rpe-integrante-form>
            <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
                <button type="reset" (click)="onCancel()" mat-raised-button routerLink="/empresas/mi-empresa">
                    {{ 'rpe.vista-usuario.volver' | translate }}
                </button>

                <button type="submit" mat-raised-button (click)="onSubmit()" color="primary" *ngIf="mostrarSubmit()">
                    {{ 'rpe.vista-usuario.confirmar' | translate }}
                </button>
            </div>
        </mat-card>
    </div>
</div>